import { render, staticRenderFns } from "./PropertyCards.vue?vue&type=template&id=7520de5f&"
import script from "./PropertyCards.vue?vue&type=script&lang=js&"
export * from "./PropertyCards.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCards.vue?vue&type=style&index=0&id=7520de5f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports